// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__SI3qJ","arrowBackIcon":"BackButton_arrowBackIcon__DDH7t","materialGroup":"BackButton_materialGroup__+IVHx","action":"BackButton_action__SCtJs"};